module.exports = __webpack_public_path__ + "img/apply-bg.d5ce48d3.png";